// src/data/products.js

// Each product has specific temperature requirements based on FDA/CDC guidelines
// This is our "source of truth" for what temperature ranges are acceptable

export const PRODUCT_PROFILES = [
  {
    id: 'PFIZER-COVID',
    type: 'mRNA Vaccine',
    name: 'Comirnaty (Pfizer-BioNTech)',
    // Ultra-cold storage requirement
    tempMin: -80,           // Minimum allowed temperature (°C)
    tempMax: -60,           // Maximum allowed temperature (°C)
    idealMin: -70,          // Ideal range start (where we WANT to be)
    idealMax: -65,          // Ideal range end
    stabilityBudgetHours: 2, // Max time allowed outside range before product is compromised
    unitValue: 150,         // Cost per unit ($) — for calculating financial impact
    shelfLifeDays: 180,     // How long product lasts in proper storage
  },
  {
    id: 'MODERNA-COVID',
    type: 'mRNA Vaccine', 
    name: 'Spikevax (Moderna)',
    // Less strict than Pfizer — can be stored in regular freezer
    tempMin: -25,
    tempMax: -15,
    idealMin: -22,
    idealMax: -18,
    stabilityBudgetHours: 12,
    unitValue: 130,
    shelfLifeDays: 180,
  },
  {
    id: 'FLU-VACCINE',
    type: 'Standard Vaccine',
    name: 'Fluzone Quadrivalent',
    // Standard refrigerator temperature (most common)
    tempMin: 2,
    tempMax: 8,
    idealMin: 4,
    idealMax: 6,
    stabilityBudgetHours: 48,
    unitValue: 25,
    shelfLifeDays: 365,
  },
  {
    id: 'HUMIRA',
    type: 'Biologic',
    name: 'Humira (Adalimumab)',
    // High-value biologic — $2800 per unit!
    tempMin: 2,
    tempMax: 8,
    idealMin: 3,
    idealMax: 7,
    stabilityBudgetHours: 24,
    unitValue: 2800,
    shelfLifeDays: 730,
  },
  {
    id: 'LANTUS',
    type: 'Insulin',
    name: 'Lantus (Insulin Glargine)',
    // Insulin is more forgiving — can survive room temp for weeks
    tempMin: 2,
    tempMax: 8,
    idealMin: 4,
    idealMax: 6,
    stabilityBudgetHours: 672, // 28 days at room temp
    unitValue: 280,
    shelfLifeDays: 730,
  },
  {
    id: 'FFP',
    type: 'Frozen Plasma',
    name: 'Fresh Frozen Plasma',
    // Blood product — critical and time-sensitive
    tempMin: -30,
    tempMax: -18,
    idealMin: -25,
    idealMax: -20,
    stabilityBudgetHours: 4,
    unitValue: 450,
    shelfLifeDays: 365,
  },
];

// Helper function to get product by ID
export const getProductById = (productId) => {
  return PRODUCT_PROFILES.find(p => p.id === productId);
};

// Get all unique product types (for filter dropdowns)
export const getProductTypes = () => {
  return [...new Set(PRODUCT_PROFILES.map(p => p.type))];
};